module.exports = __webpack_public_path__ + "img/erpNoData.fade0369.png";